import { render, staticRenderFns } from "./ModalBatchConfirm.vue?vue&type=template&id=ede8c9be&scoped=true"
import script from "./ModalBatchConfirm.vue?vue&type=script&lang=js"
export * from "./ModalBatchConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalBatchConfirm.vue?vue&type=style&index=0&id=ede8c9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede8c9be",
  null
  
)

export default component.exports